// extracted by css-extract-rspack-plugin
export default {"MaskedFormTextInput":"sputnik__MaskedFormTextInput__gggew","maskedFormTextInput":"sputnik__MaskedFormTextInput__gggew"};